module.exports = __webpack_public_path__ + "static/media/logo_favicon_urgently.3adb8406.svg";